import { Mission } from '../../lib/types/models/mission/mission'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderMissions(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getMissions.url, { id }))
    .get<Mission[]>()
}
